import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authenticateSecurityCode, resendNewSecurityCode } from '../auth/auth-slice';
import { useNavigate } from 'react-router-dom';
import OTPInput from 'react-otp-input';
import { FormattedMessage } from 'react-intl';
import { Button } from 'semantic-ui-react';

const page = 'verifySecurityCodePage';

function OtpInputContainer(securityCode, setSecurityCode) {
  return (
    <OTPInput
      value={securityCode}
      onChange={setSecurityCode}
      numInputs={5}
      renderSeparator={<span> </span>}
      renderInput={(props) => <input {...props} />}
      shouldAutoFocus
      inputStyle="security-code-input-style"
      containerStyle="security-code-container-style"
    />
  );
}

export function VerifySecurityCodePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [securityCode, setSecurityCode] = useState('');
  const [securityCodeResent, setSecurityCodeResent] = useState(false);

  const { email, secretCodeAuthenticated, itemAssignmentCode, securityCodeAuthenticationStatus, type } = useSelector(
    (state) => ({
      email: state.auth.user.email,
      secretCodeAuthenticated:
        state.auth.user.secretCodeAuthenticated && state.auth.user.email === state.auth.user.itemAssigneeEmail,
      itemAssignmentCode: state.auth.user.itemAssignmentCode,
      securityCodeAuthenticationStatus: state.auth.user.securityCodeAuthenticationStatus,
      type: state.auth.user.type,
    })
  );

  useEffect(() => {
    if (securityCodeAuthenticationStatus === 'URL Invalid') {
      navigate('/error');
    }
  });

  const clearSecurityField = () => {
    setSecurityCode('');
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(authenticateSecurityCode({ securityCode: securityCode, code: itemAssignmentCode, navigate: navigate }));
    clearSecurityField();
  };

  const showErrorMessage = () => {
    return securityCodeAuthenticationStatus === 'Invalid security code';
  };

  const handleResend = (event) => {
    if (securityCodeResent) {
      event.preventDefault();
      return;
    }
    dispatch(resendNewSecurityCode({ code: itemAssignmentCode, navigate: navigate, type }));
    clearSecurityField();
    setSecurityCodeResent(true);
    setTimeout(() => {
      setSecurityCodeResent(false);
    }, 3000);
  };

  const formattedEmail = JSON.stringify(email);
  return (
    <div className="verify-securityCode page">
      <div className="ui card">
        <div className="ui one column grid content">
          <form onSubmit={handleSubmit}>
            <div className="ui row">
              <h2 className="ui header">
                <p>
                  <i className="lock icon"></i>
                  <FormattedMessage id="common.verifyIdentity" defaultMessage="Verify your identity" />
                </p>
              </h2>
              <div className="sub-header" data-testid="email-display">
                <FormattedMessage
                  id={`${page}.inputRequest`}
                  defaultMessage={`Enter the security code that was sent to ${formattedEmail}`}
                  values={{ formattedEmail }}
                />
              </div>
            </div>
            <div>
              <div className="row">
                <div className="login-field-label">
                  <FormattedMessage id={`${page}.securityCode`} defaultMessage="Security Code" />
                </div>
              </div>
              <div className="row">{OtpInputContainer(securityCode, setSecurityCode)}</div>
            </div>
            {showErrorMessage() && !secretCodeAuthenticated && (
              <div className="ui pointing basic label form-error-message">
                <FormattedMessage
                  id={`${page}.errorMessage`}
                  defaultMessage="This code is incorrect or expired. Please try your code again or {link} be sent to your email."
                  values={{
                    link: (
                      <a href="#" onClick={handleResend}>
                        <FormattedMessage id={`${page}.requestNewCode`} defaultMessage="request a new code" />
                      </a>
                    ),
                  }}
                />
              </div>
            )}
            <div className="ui row">
              <Button className="ui green">
                <FormattedMessage id={`${page}.confirmCode`} defaultMessage="Confirm Code" />
              </Button>
            </div>
          </form>
        </div>
        <div className="ui row">
          <h2 className="ui header resend-code-header">
            <div className="sub header resend-code">
              {securityCodeResent ? (
                <div className="ui label">
                  <FormattedMessage id={`${page}.resendInfo`} defaultMessage="Security code is resent to you email" />
                </div>
              ) : (
                <div className="sub-header">
                  <FormattedMessage id={`${page}.codeNotReceived`} defaultMessage="Didn't get a code?" />{' '}
                  <a href="#" onClick={handleResend} aria-disabled={securityCodeResent}>
                    {' '}
                    <FormattedMessage id={`${page}.resendCode`} defaultMessage="Resend code" />{' '}
                  </a>
                </div>
              )}
            </div>
          </h2>
        </div>
      </div>
    </div>
  );
}
